/**
 * Shared API response envelope. The backend wraps every response in this shape.
 *
 *   success → { success: true, data: T, meta?: { ... } }
 *   error   → { success: false, error: { code, message, details? } }
 */

export type ApiMeta = {
  page?: number;
  per_page?: number;
  total?: number;
  cursor?: string | null;
};

export type ApiSuccess<T> = {
  success: true;
  data: T;
  meta?: ApiMeta;
};

export type ApiErrorPayload = {
  success: false;
  error: {
    code: string;
    message: string;
    details?: unknown;
  };
};

export type ApiEnvelope<T> = ApiSuccess<T> | ApiErrorPayload;

/** Thrown when the backend returns `{ success: false, error: { ... } }`. */
export class ApiError extends Error {
  public readonly code: string;
  public readonly details?: unknown;
  public readonly status?: number;

  constructor(message: string, code: string, status?: number, details?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    if (status !== undefined) this.status = status;
    if (details !== undefined) this.details = details;
  }
}
